"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StylePlaceholder = exports.StyleLabel = exports.StyleInput = exports.StyleDescript = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _colors = require("webmotors-react-pj/webinput/text/style/colors");
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleLabel = exports.StyleLabel = _styledComponents.default.label.withConfig({
  displayName: "StyleLabel",
  componentId: "sc-n6l86u-0"
})(["position:relative;display:block;border:2px solid;display:flex;align-items:center;border-color:", ";border-radius:8px;background-color:", ";transition:border-color 0.3s;opacity:", ";pointer-events:", ";&.input-lock{opacity:0.6;pointer-events:none;}> [data-src]{width:24px;height:24px;fill:", ";position:relative;.icon{width:100%;height:100%;}&:nth-child(1){margin-left:16px;}&:last-child{margin-right:8px;}}"], props => (0, _colors.borderColor)(props), (0, _color.default)('white'), _ref => {
  let {
    disabled
  } = _ref;
  return disabled && 0.6;
}, _ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled && 'none';
}, props => (0, _colors.inputColor)(props));
const StylePlaceholder = exports.StylePlaceholder = _styledComponents.default.span.withConfig({
  displayName: "StylePlaceholder",
  componentId: "sc-n6l86u-1"
})(["position:absolute;left:0;top:", ";transform:", ";margin-top:", ";padding:0 12px;font-weight:500;font-size:", ";;line-height:150%;background-color:", ";color:", ";transition:top 0.3s,margin-top 0.3s,transform 0.3s,color 0.3s;will-change:top,margin-top,transform;cursor:text;@media ", ",", "{font-size:1.2rem;}"], _ref3 => {
  let {
    active
  } = _ref3;
  return active ? '0%' : '50%';
}, _ref4 => {
  let {
    iconLeft
  } = _ref4;
  return iconLeft ? 'translate(41px, -50%)' : 'translate(5px, -50%)';
}, _ref5 => {
  let {
    active
  } = _ref5;
  return active ? '0px' : '1px';
}, _ref6 => {
  let {
    active
  } = _ref6;
  return active ? '8px' : '12px';
}, (0, _color.default)('white'), props => (0, _colors.placeholderColor)(props), _responsive.default.lg, _responsive.default.md);
const StyleInput = exports.StyleInput = _styledComponents.default.input.withConfig({
  displayName: "StyleInput",
  componentId: "sc-n6l86u-2"
})(["font-weight:500;font-size:1.2rem;line-height:1.5em;padding:10px 16px 8px;border-style:none;border-radius:4px;outline-style:none;background-color:transparent;width:100%;color:", ";transition:color 0.3s,width 0.3s;-webkit-user-select:text;user-select:text;"], props => (0, _colors.inputColor)(props));
const StyleDescript = exports.StyleDescript = _styledComponents.default.div.withConfig({
  displayName: "StyleDescript",
  componentId: "sc-n6l86u-3"
})(["min-height:20px;font-size:1rem;line-height:1.5em;margin-bottom:12px;font-weight:500;padding-top:4px;"]);